import type React from "react";

import { translate } from "app/filters/i18nFilter";
import type { CompanyCard } from "app/pages/sales-intelligence/modules/company-analysis/types/company";
import { CompanyDataItem } from "app/pages/sales-intelligence/pages/company-analysis/containers/overview/CompanyData/CompanyDataItem";
import { StyledGrid } from "app/pages/sales-intelligence/pages/company-analysis/containers/overview/CompanyData/styles";
import type { FieldsConfig } from "app/pages/sales-intelligence/pages/company-analysis/containers/overview/CompanyData/utils";

export type DataSectionProps = {
    fields: readonly FieldsConfig[];
    data: CompanyCard;
    columnsNumber: number;
    flex: string;
    minWidth?: number;
    gap: string;
};

export const DataSection: React.FC<DataSectionProps> = ({ fields, data, ...gridProps }) => (
    <StyledGrid {...gridProps}>
        {fields.map((field) => (
            <CompanyDataItem
                key={field.key}
                fieldKey={field.key}
                title={translate(`si.company-analysis.company-data.card.field.${field.key}`)}
                badge={field.badge}
                value={field.render ? field.render(data[field.key]) : (data[field.key] as string)}
                annotation={field.getAnnotation?.({ data })}
            />
        ))}
    </StyledGrid>
);
